import { createMakeAndWithStyles } from "tss-react";
import { useTheme } from "@mui/material/styles";

// Create tss-react makeStyles that is backward compatible with @mui/styles
const { makeStyles: tssReactMakeStyles } = createMakeAndWithStyles({ useTheme });

// Wrapper to maintain backward compatibility with @mui/styles API
// @mui/styles: const useStyles = makeStyles(...); const classes = useStyles();
// tss-react: const useStyles = makeStyles()(...); const { classes } = useStyles();
// TODO(types): tss-react styles dict signature; intentionally loose for backward compat
export const makeStyles = (stylesOrCreator: any) => {
  const useTssStyles = tssReactMakeStyles()(stylesOrCreator);

  // Return a hook that returns classes directly (not { classes })
  return () => {
    const { classes } = useTssStyles();
    return classes;
  };
};
